import { useCallback } from 'react';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { buildService } from './service';
import serviceMethods from './service_methods';
const api = buildService('/business_units/{id}/user_access_business_unit_participations', {
  only: ['create', 'update', 'delete']
});
const userAccessBusinessUnitParticipationsService = {
  useDeleteUserAccessBusinessUnitParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading) {
    return useErrorHandling(useCallback(async (selectedUserAccess, participation, businessUnitId) => {
      setLoading(true);
      await api.delete(businessUnitId, participation.id);
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === selectedUserAccess.id);
      userAccessInClaimGroup.user_access_business_unit_participations = userAccessInClaimGroup.user_access_business_unit_participations.filter(existingParticipation => existingParticipation.id !== parseInt(participation.id));
      setClaimGroup({
        ...claimGroup
      });
    }, [claimGroup, setClaimGroup, setLoading]), useCallback(() => {
      setLoading(false);
    }, [setLoading]));
  },
  useCreateUserAccessBusinessUnitParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading) {
    return useErrorHandling(useCallback(async (selectedUserAccess, businessUnitId) => {
      setLoading(true);
      const newParticipation = await api.create(businessUnitId, {
        user_access_id: selectedUserAccess.id
      });
      const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === selectedUserAccess.id);
      userAccessInClaimGroup.user_access_business_unit_participations.push(newParticipation);
      setClaimGroup({
        ...claimGroup
      });
    }, [claimGroup, setClaimGroup, setLoading]), useCallback(() => {
      setLoading(false);
    }, [setLoading]));
  },
  useUpdate(claimGroup, setClaimGroup) {
    const update = serviceMethods.useUpdate({
      callback: useCallback(async _ref => {
        let {
          user_access_business_unit_participation
        } = _ref;
        const updated = await api.update(user_access_business_unit_participation.business_unit_id, user_access_business_unit_participation.id, {
          user_access_business_unit_participation
        });
        const userAccessInClaimGroup = claimGroup.user_accesses.find(userAccess => userAccess.id === updated.user_access_id);
        const index = userAccessInClaimGroup.user_access_business_unit_participations.findIndex(participation => participation.id === updated.id);
        userAccessInClaimGroup.user_access_business_unit_participations[index] = updated;
        setClaimGroup({
          ...claimGroup
        });
        return updated;
      }, [claimGroup, setClaimGroup])
    });
    return update;
  }
};
export default userAccessBusinessUnitParticipationsService;